import { addDoc, collection, getDocs, query, where } from "firebase/firestore";

import { firestore } from "@/firebase.config";
import { GetTaskNotesPropsType, NotesPropsType } from "@/src/domain/notes";
import { logger } from "@/src/utils/logger";

import { SpikeSosDb } from "./SpikesosDb";

export const NoteApi = {
  listTaskNotes: async ({
    jobId,
    serviceId,
    taskId,
  }: GetTaskNotesPropsType) => {
    try {
      const notesCollection = SpikeSosDb.notes;
      const notesQuery = query(
        notesCollection,
        where("jobId", "==", jobId),
        where("serviceId", "==", serviceId),
        where("taskId", "in", ["", taskId]),
      );

      const notesSnapshot = await getDocs(notesQuery);

      const notes = notesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      return notes;
    } catch (error) {
      logger.error("Error fetching task notes", error);

      throw error;
    }
  },
  addNote: async (params: NotesPropsType) => {
    try {
      const { serviceId, jobId, taskId, ...noteParams } = params;

      if (!jobId || !serviceId || !taskId) {
        throw new Error("Missing required parameters");
      }
      const notesCollection = collection(
        firestore,
        `jobs/${jobId}/services/${serviceId}/notes`,
      );
      const noteSnapshot = await addDoc(notesCollection, {
        ...noteParams,
        serviceId,
        jobId,
        taskId,
      });

      return noteSnapshot.id;
    } catch (error) {
      logger.error("Error adding note", error);

      throw error;
    }
  },
};
